import type { Routes } from '@angular/router';

export const AGGREGATED_PLATFORMS_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'connection',
        pathMatch: 'full',
    },
    {
        path: 'connection',
        loadComponent: () =>
            import('#modules/platforms/views/aggregated-platforms/aggregated-platforms.component').then(
                (m) => m.AggregatedPlatformsComponent
            ),
    },
];
